/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
    FETCH_AGENTS,
    FETCH_AGENTS_STATUS,
    GET_JOBS_RUNNING,
    POLL_AGENTS_START,
    POLL_AGENTS_STOP,
    POLL_AGENTS_STATUS_START,
    POLL_AGENTS_STATUS_STOP,
    POLL_JOBS_RUNNING_START,
    POLL_JOBS_RUNNING_STOP
  } from './actionTypes'
  import {
    call,
    put,
    takeEvery,
    takeLatest,
    take,
    cancel,
    delay
  } from 'redux-saga/effects'
  import { Agents } from './agents'

  import {
  fetchAgentsSuccess,
  fetchAgentsFailure,
  fetchAgentsStatusSuccess,
  fetchAgentsStatusFailure,
  fetchJobsRunningSuccess,
  fetchJobsRunningFailure
} from './actions'

function* getJobsCountpoll(){
    try{
        const response = yield call(Agents.getRunningJobs)
        yield put(fetchJobsRunningSuccess(response.data))
    }catch(error){
        yield put(fetchJobsRunningFailure(error));
    }
}

function* fetchAgentspoll(){
    try{
      const response = yield call(Agents.get)
      yield put(fetchAgentsSuccess(response.data))
    }catch(error){
        yield put(fetchAgentsFailure(error));
    }
}

function* fetchAgentsStatuspoll(){
    try{
      const response = yield call(Agents.getStatus)
      yield put(fetchAgentsStatusSuccess(response.data))
    }catch(error){
        yield put(fetchAgentsStatusFailure(error));
    }
}

function* pollJobsCount(action) {
    while (true) {
      yield delay(30000)
      yield call(getJobsCountpoll)
    }
}

function* pollAgents(action) {
    while (true) {
      yield delay(30000)
      yield call(fetchAgentspoll)
    }
}

function* pollAgentsStatus(action) {
    while (true) {
      yield delay(5000)
      yield call(fetchAgentsStatuspoll)
    }
}

export function* jobsCountRequestSaga() {
    yield takeEvery(GET_JOBS_RUNNING, getJobsCountpoll)
}

export function* jobsCountPollingSaga() {
    while (true) {
        const watcherInstance = yield takeLatest(POLL_JOBS_RUNNING_START, pollJobsCount)
        yield take(POLL_JOBS_RUNNING_STOP)
        yield cancel(watcherInstance)
    }
}

export function* agentsRequestSaga() {
    yield takeEvery(FETCH_AGENTS, fetchAgentspoll)
}

export function* agentsPollingSaga() {
    while (true) {
        const watcherInstance = yield takeLatest(POLL_AGENTS_START, pollAgents)
        yield take(POLL_AGENTS_STOP)
        yield cancel(watcherInstance)
    }
}


export function* agentsStatusRequestSaga() {
    yield takeEvery(FETCH_AGENTS_STATUS, fetchAgentsStatuspoll)
}

export function* agentsStatusPollingSaga() {
    while (true) {
        const watcherInstance = yield takeLatest(POLL_AGENTS_STATUS_START, pollAgentsStatus)
        yield take(POLL_AGENTS_STATUS_STOP)
        yield cancel(watcherInstance)
    }
}

